import React, { useState } from 'react'
import { Button, Icon, theme } from '@dasa-health/components-react'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { MiscOutlineQuestioncircle } from '@dasa-health/icons'
import { ModalDataContainer } from '../style'

export const SocialNameModalButton = () => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <div>
                <Button borderRadius="pill" onClick={() => setIsOpen(true)} size="compact" type="button" variant="tertiary">
                    <Icon color={theme.colors.black} size={26}>
                        <MiscOutlineQuestioncircle />
                    </Icon>
                </Button>
            </div>
            {isOpen && (
                <ModalDataContainer>
                    <SignUpModal
                        setShowModal={() => {
                            setIsOpen(v => !v)
                        }}
                        showModal={isOpen}
                        title="O que é nome social?"
                    >
                        <p>
                            Nome social é o nome pelo qual pessoas transexuais, travestis ou outras preferem ser chamadas no dia a dia,
                            ao invés de seu nome registrado em cartório no nascimento, que não reflete a sua identidade de gênero.
                        </p>

                        <p>
                            De acordo com o Decreto Nº 8.727 de 28 de abril de 2016 dispõe sobre o uso do nome social e o
                            reconhecimento da identidade de gênero de pessoas travestis ou transexuais no âmbito da administração
                            pública federal direta, autárquica e fundacional.
                        </p>
                    </SignUpModal>
                </ModalDataContainer>
            )}
        </>
    )
}
